import styled, { css } from 'styled-components';

export const Paragraph = styled.div`
  width: ${({ width = '100%' }) => width};
  font-weight: ${({ fontWeight = 'normal' }) => fontWeight};
  font-size: ${({ fontSize = '14px' }) => fontSize};
  letter-spacing: ${({ letterSpacing = '0.04em' }) => letterSpacing};
  text-align: left;
  color: ${({ color = '#888', theme }) => theme.colors[color] || color};
  ${({ lineHeight }) => lineHeight && `line-height: ${lineHeight};`}
  ${({ textOverflow = 'ellipsis' }) =>
    textOverflow === 'ellipsis' &&
    css`
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: ${({ lineClamp = 1 }) => lineClamp};
      -webkit-box-orient: vertical;
    `}
`;
